import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"

import {useLocks as useItems} from "../../contexts/LockContext"

import ItemForm from "../../components/Locks/Form"
import ItemView from "../../components/Locks/View"

import LockingSystemPermissionsList from "../../components/Locks/LockLockingSystemPermissions/List"

import PageItem from "../common/Item"
import NotFound from "../../components/Locks/NotFound"

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}


const PageLocksItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()

    const
        itemType:     string = 'Lock',
        itemTypeName: string = t('locks.title_item'),
        itemTypeUrl:  string = 'locks'

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemForm={ItemForm}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            LockingSystemPermissionsList={LockingSystemPermissionsList}
            segment={match.params.segment}
        />
    )
}

export default PageLocksItem